module.exports = __webpack_public_path__ + "img/a685.d2122603.png";